module.exports = __webpack_public_path__ + "static/media/thumbnail.73aa94cb.jpg";